import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + '/api/v1';

export interface SubscriptionStatus {
  subscribed: boolean;
  email: string;
}

// getMySubscription récupère l'état actuel d'abonnement au rapport hebdomadaire
// Minigrid pour l'utilisateur authentifié. Le serveur résout l'email canonique
// via le JWT (UserID + AccountID → domainModel/account/info), donc on n'a rien
// à envoyer dans la requête.
export async function getMySubscription(): Promise<SubscriptionStatus> {
  const res = await axios.get<SubscriptionStatus>(
    `${BACKEND_URL}/weekly-report/me/subscription`,
  );
  return res.data;
}

// setMySubscription bascule l'abonnement (désabonne si subscribed=false,
// réabonne si true). Le serveur enregistre la source "Settings" pour audit.
export async function setMySubscription(subscribed: boolean): Promise<SubscriptionStatus> {
  const res = await axios.post<SubscriptionStatus>(
    `${BACKEND_URL}/weekly-report/me/subscription`,
    { subscribed },
  );
  return res.data;
}
